import { Building2, CheckCircle2, ExternalLink, Globe, MapPin, Trash2, XCircle } from "lucide-react";

export const getAddressColumns = ({
  onViewShipment,
  handleDelete,
}) => [
  {
    key: "companyName",
    label: "Company Name",
    render: (row) => (
      <div className="flex items-center gap-3 w-[200px] max-w-[200px]">
        <div className="w-8 h-8 flex-shrink-0 bg-teal-100 dark:bg-teal-900/30 rounded-lg flex items-center justify-center">
          <Building2 className="w-4 h-4 text-teal-600 dark:text-teal-400" />
        </div>
        <span
          className="text-sm font-semibold cursor-pointer"
          onClick={() => onViewShipment(row?.addressID)}
        >
          {row?.customerName}
        </span>
      </div>
    ),
  },

  {
    key: "edi",
    label: "EDI Code",
    render: (row) => (
      <span
        className={`text-sm font-mono cursor-pointer flex items-center gap-1 ${
          row?.accountNumber === "NA"
            ? "text-slate-400"
            : "text-blue-600 underline"
        }`}
        onClick={() => onViewShipment(row?.addressID)}
      >
        {row?.accountNumber}
        {row?.accountNumber && <ExternalLink className="w-2.5 h-2.5" />}
      </span>
    ),
  },

  {
    key: "address",
    label: "Address",
    render: (row) => (
      <div className="flex items-center gap-2 w-[220px]">
        <MapPin className="w-4 h-4 text-slate-400" />
        <span className="text-sm text-slate-600 dark:text-slate-400">{row?.address1}</span>
      </div>
    ),
  },

  {
    key: "city",
    label: "City",
  },

  {
    key: "state",
    label: "State",
  },

  {
    key: "country",
    label: "Country",
    render: (row) => (
      <div className="flex items-center gap-2">
        <Globe className="w-4 h-4 text-slate-400" />
        <span>{row?.country}</span>
      </div>
    ),
  },

  {
    key: "companyCode",
    label: "Company Code",
    render: (row) => (
      <span className="px-2 py-1 bg-slate-100 rounded text-xs font-mono">
        {row?.companyCode}
      </span>
    ),
  },

  {
    key: "officeType",
    label: "Office Type",
    render: (row) =>
      row?.officeTypeID
        ? row?.officeTypeID == 1
          ? "Head Office"
          : "Branch Office"
        : "-",
  },

  {
    key: "status",
    label: "Status",
    render: (row) => (
      <div
       className={`flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all
            ${
              row?.active
                ? "bg-green-100 text-green-700 hover:bg-green-200"
                : "bg-red-100 text-red-700 hover:bg-red-200"
            }`}
      >
          {row?.active ? (
            <>
              <CheckCircle2 size={14} />
              Active
            </>
          ) : (
            <>
              <XCircle size={14} />
              Inactive
            </>
          )}
      </div>
    )
  },

  {
    key: "action",
    label: "Action",
    render: (row) => (
      <div className="flex justify-center">
        <button
          className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200"
          onClick={() => handleDelete(row?.addressID)}
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    ),
  },
];